import React from 'react'
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'
import { Input } from 'antd'
import { GoogleOutlined } from '@ant-design/icons'
import _ from 'lodash'

const AutoComplete = (props) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      types: ['address'],
      componentRestrictions: {
        country: 'it',
      },
    },
    debounce: 300,
  })

  const handleInput = (e) => {
    // Update the keyword of the input element
    setValue(e.target.value)
    props.form.setFieldsValue({
      indirizzo: e.target.value,
      citta: undefined,
      CAP: undefined,
      lat: undefined,
      lng: undefined,
      numeroCivico: undefined,
      provincia: undefined,
      regione: undefined,
      country: undefined,
    })
    props.addValue({
      indirizzo: e.target.value,
      citta: undefined,
      CAP: undefined,
      lat: undefined,
      lng: undefined,
      numeroCivico: undefined,
      provincia: undefined,
      regione: undefined,
      country: undefined,
    })
  }

  const handleSelect = ({ description = '' }) => () => {
    // When user selects a place, we can replace the keyword without request data from API
    // by setting the second parameter as "false"
    setValue(description, false)
    clearSuggestions()

    // Get latitude and longitude via utility functions
    getGeocode({ address: description }).then(async (results) => {
      const { address_components } = results[0]
      const { lat, lng } = await getLatLng(results[0])
      props.setLocation({
        lat,
        lng,
      })
      const indirizzo = _.get(
        _.find(address_components, (item) => _.includes(item.types, 'route')),
        'long_name',
        ''
      )
      const numeroCivico = _.get(
        _.find(address_components, (item) =>
          _.includes(item.types, 'street_number')
        ),
        'long_name',
        ''
      )
      const citta = _.get(
        _.find(
          address_components,
          (item) =>
            _.includes(item.types, 'locality') ||
            _.includes(item.types, 'administrative_area_level_3')
        ),
        'long_name',
        ''
      )
      const CAP = _.get(
        _.find(address_components, (item) =>
          _.includes(item.types, 'postal_code')
        ),
        'long_name',
        ''
      )
      const provincia = _.get(
        _.find(address_components, (item) =>
          _.includes(item.types, 'administrative_area_level_2')
        ),
        'short_name',
        ''
      )
      const regione = _.get(
        _.find(address_components, (item) =>
          _.includes(item.types, 'administrative_area_level_1')
        ),
        'long_name',
        ''
      )
      const country = _.get(
        _.find(address_components, (item) => _.includes(item.types, 'country')),
        'long_name',
        ''
      )
      props.addValue({
        indirizzo: _.trimEnd(`${indirizzo} ${numeroCivico}`),
        citta,
        CAP,
        lat,
        lng,
        strada: indirizzo,
        numeroCivico,
        provincia,
        regione,
        country,
      })
      props.form.setFieldsValue({
        indirizzo: _.trimEnd(`${indirizzo} ${numeroCivico}`),
        citta,
        CAP,
        lat,
        lng,
        strada: indirizzo,
        numeroCivico,
        provincia,
        regione,
        country,
      })
    })
  }

  const suggestions = () => {
    return (
      <>
        {_.map(data, (suggestion) => {
          const {
            id,
            structured_formatting: { main_text, secondary_text },
          } = suggestion

          return (
            <li
              key={id}
              onClick={handleSelect(suggestion)}
              className="p-2 hover:bg-gray-200 cursor-pointer flex justify-start items-center"
            >
              <i className="material-icons text-gray-500">location_on</i>
              <span>
                <strong>{main_text} </strong>
                <small>{secondary_text}</small>
              </span>
            </li>
          )
        })}
        <li className="flex justify-end items-center">
          Powered By <GoogleOutlined className="text-lg p-2" />
        </li>
      </>
    )
  }
  return (
    <>
      <Input
        value={_.get(props.formValue, 'indirizzo')}
        onChange={handleInput}
        disabled={!ready}
        placeholder="Cerca Indirizzo"
      />
      {status === 'OK' && (
        <div className="absolute w-full z-50 bg-white shadow-lg text-md">
          {suggestions()}
        </div>
      )}
    </>
  )
}

export default AutoComplete
